import {pipe, pick, omit, merge, evolve} from 'ramda';
import {over} from 'utils/lenses';
import {
	buildingsFiltersKeys,
	emptyBuildingsFilters,
	massSelectionLimit,
} from './constants';

export const getBuildingsType = type => {
	let q = '';

	if (type === 'house') {
		q = {
			types: 'detached,semidetached,otherdetached,unknown,vacationhome',
			onlyWithProjectBuildingId: false,
		};
	} else if (type === 'project') {
		q = {
			types:
				'apartmenthouse,other,rowhouse,balconyaccessblock,terracedhouse,detachedhousecompany',
			onlyWithProjectBuildingId: false,
		};
	} else if (type === 'condo') {
		q = {
			types:
				'apartmenthouse,other,rowhouse,balconyaccessblock,terracedhouse,detachedhousecompany',
			onlyWithProjectBuildingId: true,
		};
	}

	return q;
};

// PERM: Currently not used, old buildings app had MassEditor exception for this. Probably legacy.
export const isContactUpdater = user =>
	!!user.roles.find(r => r.slug === 'kontaktinpaeivitys');

export const formatBuildingsFiltersInput = ({buildingsQuery}) => {
	const urlQueryVals = pick(buildingsFiltersKeys, buildingsQuery);
	const filters = {
		...emptyBuildingsFilters,
		...urlQueryVals,
	};

	return filters;
};

export const formatMassSelectionQuery = buildingsQuery => {
	const massSelectVals = {
		_limit: massSelectionLimit,
		onlyIds: true,
		_select: 'id',
	};
	const selection = pipe(
		omit(['_limit', '_page', '_sortDirection', '_sortColumn']),
		merge(massSelectVals),
	)(buildingsQuery);

	return selection;
};

export const parseUrlQuery = query => {
	return evolve({areas: str => (str ? JSON.parse(str) : [])}, query);
};

export const formatUrlQuery = ({buildingsQuery}) => {
	return buildingsQuery.areas
		? over(['areas'], JSON.stringify, buildingsQuery)
		: buildingsQuery;
};

export const formatFetchableBuildingsQuery = buildingsQuery => {
	return buildingsQuery.areas
		? over(['areas'], areas => areas.map(a => a.id).join(','), buildingsQuery)
		: buildingsQuery;
};
